export default {
  card: {
    flexDirection: 'column',
    position: 'relative',
  },
  container: {
    mt: '1rem',
  },
  grid: {
    flex: 1,
    gridTemplateColumns: ['repeat(1,1fr)', '1fr 2fr'],
  },
  imageContainer: {
    flexDirection: 'column',
    borderRadius: '10px',
  },
  bgImageContainer: {
    boxShadow: (t) => `0 3px 6px ${t.colors.shadow}`,
    borderRadius: '10px',
  },
  imageInnerContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    borderRadius: '10px',
  },
  image: {
    display: 'flex',
    flex: 1,
    objectFit: 'cover',
    borderRadius: '10px',
  },
  missingPhotoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    bg: 'content_bg',
    p: 4,
  },
  missingPhoto: {
    fontSize: '25px',
    color: 'text',
  },
  infoContainer: {
    flexDirection: 'column',
    px: [null, null, null, null, '1rem'],
    py: '1rem',
    boxShadow: (t) => `0 3px 6px ${t.colors.shadow}`,
    borderRadius: '10px',
    bg: 'content_bg',
  },
  headerContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {},
  textRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  label: {
    fontSize: ['14px', null, '16px'],
    color: 'text_secondary',
  },
  value: {
    fontSize: ['14px', null, '16px'],
  },
  valueDisabled: {
    fontSize: ['14px', null, '16px'],
    color: 'text_disabled',
  },
  bioContainer: {
    flex: 1,
    flexDirection: 'column',
    boxShadow: (t) => `0 3px 6px ${t.colors.shadow}`,
    borderRadius: '10px',
    p: '1rem',
    my: '2rem',
    bg: 'content_bg',
  },
  bioTextContainer: {
    bg: 'card_bg_hover',
    my: '0.5rem',
    borderRadius: '10px',
  },
  bio: {
    fontSize: ['14px', null, '16px'],
    m: '0.5rem',
  },
  logoutContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  logoutButton: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    transition: '0.4s',
    cursor: 'pointer',
    color: 'text_secondary',
    '&:hover': {
      color: 'error',
    },
  },
  logoutText: {
    mr: '5px',
    fontSize: ['12px', '14px', null, '16px'],
  },
  separator: {
    m: 0,
  },
};
